import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "wyatt-countdown",
  class WyattCountdown extends WYATTElement {
    connectedCallback() {
      const interval = setInterval(() => {
        const eventLocalTime =
          new Date(this.eventDateTimeString).getTime() +
          this.getEasternOffset();
        const nowLocalTime = new Date().getTime();
        const timeUntilEvent = eventLocalTime - nowLocalTime;

        if (timeUntilEvent > 0) {
          const days = Math.floor(timeUntilEvent / (1000 * 60 * 60 * 24));
          const hours = Math.floor(
            (timeUntilEvent % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
          );
          const minutes = Math.floor(
            (timeUntilEvent % (1000 * 60 * 60)) / (1000 * 60),
          );
          const seconds = Math.floor((timeUntilEvent % (1000 * 60)) / 1000);
          this.innerHTML = `${days}d ${hours}h ${minutes}m ${seconds}s`;
        } else {
          clearInterval(interval);
          this.innerHTML = "0d 0h 0m 0s";
        }
      }, 1000);
    }

    eventDateTimeString = `${this.dataset.dateTime.replace(" ", "T")}:00Z`;

    getEasternOffset = () => {
      const localDate = new Date();
      const stdTimezoneOffset = () => {
        const jan = new Date(0, 1);
        const jul = new Date(6, 1);
        return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
      };
      const observingDaylightSavingTime =
        localDate.getTimezoneOffset() < stdTimezoneOffset();

      return observingDaylightSavingTime ? 4 * 3600000 : 5 * 3600000;
    };
  },
);
